import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import VideoViewer from '../components/quest/activity/VideoViewer'
import CreateNewCourseModal from '../components/modal/CreateOrEditCourseModal/CreateNewCourseModal'
import InformativeModal from '../components/modal/InformativeModal'
import CloseModal from '../components/modal/CloseModal'
import EditCourseModal from '../components/modal/CreateOrEditCourseModal/EditCourseModal'
import CreateJourneyModal from '../components/modal/CreateJourneyModal'
import EditJourneyModal from '../components/modal/CreateOrEditCourseModal/EditJourneyModal'
import CreateOrEditLevelModal from '../components/modal/CreateOrEditLevelModal'
import SortLevelOrderModal from '../components/modal/SortLevelOrder/SortLevelOrderModal'
import CreateActivityModal from '../components/modal/CreateActivityModal'
import ChangeLevelForActivityModal from '../components/modal/ChangeLevelForActivityModal'
import AddOrRemoveActivityIcon from '../components/modal/AddOrRemoveActivityIconModal'
import AddOrEditMentorFile from '../components/modal/AddOrEditMentorFile'
import GeneralErrorModal from '../components/modal/GeneralErrorModal'
import AddResourceModal from '../components/modal/AddResourceModal'
import EditResourceModal from '../components/modal/EditResourceModal'
import DeleteResourceModal from '../components/modal/DeleteResourceModal'
import PublishActivityModal from '../components/modal/PublishActivityModal'
import EditPublishedActivityModal from '../components/modal/EditPublishedActivityModal'
import PublishJourneyModal from '../components/modal/PublishJourneyModal'
import StarterCourseModal from '../components/modal/CreateOrEditCourseModal/StarterCourseModal'
import StarterJourneyModal from '../components/modal/CreateOrEditCourseModal/StarterJourneyModal'

const MODAL_COMPONENTS = {
  GENERAL_ERROR_MODAL: GeneralErrorModal,
  VIDEO_VIEWER: VideoViewer,
  STARTER_COURSE_MODAL: StarterCourseModal,
  CREATE_NEW_COURSE_MODAL: CreateNewCourseModal,
  INFORMATIVE_MODAL: InformativeModal,
  CLOSE_MODAL: CloseModal,
  EDIT_COURSE_MODAL: EditCourseModal,
  STARTER_JOURNEY_MODAL: StarterJourneyModal,
  CREATE_JOURNEY_MODAL: CreateJourneyModal,
  EDIT_JOURNEY_MODAL: EditJourneyModal,
  CREATE_OR_EDIT_LEVEL_MODAL: CreateOrEditLevelModal,
  SORT_LEVEL_ORDER_MODAL: SortLevelOrderModal,
  CREATE_ACTIVITY_MODAL: CreateActivityModal,
  CHANGE_LEVEL_FOR_ACTIVITY_MODAL: ChangeLevelForActivityModal,
  ADD_OR_REMOVE_ACTIVITY_ICON_MODAL: AddOrRemoveActivityIcon,
  ADD_OR_EDIT_MENTOR_FILE: AddOrEditMentorFile,
  ADD_RESOURCE_MODAL: AddResourceModal,
  EDIT_RESOURCE_MODAL: EditResourceModal,
  DELETE_RESOURCE_MODAL: DeleteResourceModal,
  PUBLISH_ACTIVITY_MODAL: PublishActivityModal,
  EDIT_PUBLISHED_ACTIVITY_MODAL: EditPublishedActivityModal,
  PUBLISH_JOURNEY_MODAL: PublishJourneyModal,

}

const ModalContainer = ({ modalType, modalProps }) => {
  if (!modalType) {
    return null
  }

  const SpecificModal = MODAL_COMPONENTS[modalType]
  return <SpecificModal {...modalProps} />
}

ModalContainer.propTypes = {
  modalType: PropTypes.string,
  modalProps: PropTypes.object
}

export default connect(state => state.modal)(ModalContainer)



// WEBPACK FOOTER //
// ./src/containers/ModalContainer.js